import { colors } from 'ui/theme/colors';
import { ChevronRight16 } from 'ui/icons/navigation/ChevronRight16';
import { PieChartIcon } from './PieChartIcon';
import { BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE } from './constants';
import type { BrandAffinityXAIProps } from './types';

import {
  BrandAffinityXAIContainer,
  BrandAffinityXAIPrompt,
  BrandAffinityXAIButton,
  BrandAffinityXAIIndicator,
} from './BrandAffinity.styles';

export const BrandAffinityXAI = ({
  affinityText,
  containerLabel,
  level,
  setXAIStatus,
}: BrandAffinityXAIProps) => {
  return (
    <BrandAffinityXAIContainer data-test={containerLabel}>
      <BrandAffinityXAIIndicator data-level={level}>
        <PieChartIcon percentage={BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE[level]} />
        {affinityText}
      </BrandAffinityXAIIndicator>
      <BrandAffinityXAIPrompt
        data-test="brand-affinity-indicator-xai-button"
        onClick={() => setXAIStatus(true)}
      >
        <BrandAffinityXAIButton>Explore</BrandAffinityXAIButton>
        <ChevronRight16 color={colors.purple50} width={10} height={10} />
      </BrandAffinityXAIPrompt>
    </BrandAffinityXAIContainer>
  );
};
